import { request } from '../../api/actions'
import { link_for_resource } from '../../../url'

// ////////////////////////////////////////////////////////////////// IMPORT END
// /////////////////////////////////////////////////////////////////////////////

const REPORT_REQUEST = 'entities/report.REQUEST'
const REPORT_SUCCESS = 'entities/report.SUCCESS'
const REPORT_FAILURE = 'entities/report.FAILURE'

function report(resource, message) {
  return request({
    url: `/api/report/${resource.type}/${resource.id}`,
    method: 'POST',
    json: { body: message },
    start: REPORT_REQUEST,
    success: {
      type: REPORT_SUCCESS,
      redirect: payload => {
        return link_for_resource(resource.type, resource.id)
      },
    },
    failure: REPORT_FAILURE,
  })
}

// /////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////// EXPORT DEFAULT
export { report, REPORT_REQUEST, REPORT_SUCCESS, REPORT_FAILURE }
